import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { hasPermission, hasFullAccess, isLeadershipAdmin } from '@/utils/roleAccess';
import { LEADERSHIP_MENU } from '@/config/navigationMenus';
import { IITH } from '@/pages/landing/iithBrand';

/** Horizontal permission-based menu for Management / leadership home. */
export default function LeadershipMenu({ accent = IITH.saffron }) {
  const { user } = useAuth();
  const hasPerms = Array.isArray(user?.permissions) && user.permissions.length > 0;
  const leadershipFallback = !hasPerms && isLeadershipAdmin(user);

  const items = LEADERSHIP_MENU.filter((item) => {
    if (hasFullAccess(user) || hasPermission(user, item.permission)) return true;
    return leadershipFallback;
  });

  if (!items.length) return null;

  return (
    <nav
      className="sticky top-14 z-20 flex flex-wrap gap-1 px-4 sm:px-8 py-2.5 bg-white/95 backdrop-blur border-b border-[#D5DEE8] shadow-sm"
      data-testid="leadership-menu"
      aria-label="Hospital screens"
    >
      <div className="max-w-[1500px] w-full mx-auto flex flex-wrap gap-1">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={Boolean(item.end)}
            data-testid={item.testid}
            className={({ isActive }) =>
              `px-3 py-1.5 rounded-md text-xs font-semibold transition ${
                isActive ? 'text-white shadow-sm' : 'text-[#071B34] hover:bg-[#E8EEF5]'
              }`
            }
            style={({ isActive }) => (isActive ? { background: accent } : undefined)}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
